module.exports = __webpack_public_path__ + "img/Hatchback_Back.732f83b1.svg";